import { Component, OnInit, Input, OnChanges, ViewChild } from "@angular/core";
import { filter, map } from "lodash";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { school } from "../../store/schools/state";

@Component({
  selector: "lightbox-table",
  templateUrl: "./lightbox-table.component.html",
  styleUrls: ["./lightbox-table.component.scss"],
})
export class LightboxTableComponent implements OnInit, OnChanges {
  @Input() columns: string[];
  @Input() seriesData;
  @Input() dataPrefix: string;
  @Input() dataSuffix: string;
  @Input() roundTo: number;
  @Input() descriptor: string;
  @Input() max: number;
  @Input() compareBy: string;
  @Input() historicalSchools: Array<school>;

  displayedColumns: string[];
  dataSource: MatTableDataSource<Object>;
  pageSize = 25;

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor() {}

  ngOnInit() {}

  ngOnChanges(change) {
    if (change && change.seriesData) {
      // transform the seriesData into objects which have all the time periods as object keys and y values as object values
      this.dataSource = new MatTableDataSource(
        map(this.seriesData, (series: Series) => {
          return Object.assign(
            { seriesName: series.name, stack: series.stack },
            ...series.data.map((point: Point) => {
              return { [point.name]: point };
            })
          );
        })
      );
      this.customSort();
      this.dataSource.paginator = this.paginator;
      this.displayedColumns = ["seriesName", ...this.columns];
    }
  }

  /** custom sort: null or blank values should always stay on bottom */
  customSort() {
    this.dataSource.sortingDataAccessor = (item, property) => {
      // Check for null values to make sure they are sorted to the bottom of the list
      if (
        !item[property] ||
        item[property].y === "" ||
        item[property].y == null
      ) {
        if (this.sort.direction === "asc") {
          return this.max + 1;
        } else {
          return -1;
        }
      } else {
        return item[property].y;
      }
    };
    this.dataSource.sort = this.sort;
  }

  getSystemSchoolNameFromStack(stackId) {
    if (this.compareBy !== "School") {
      return stackId;
    }
    let matchingSchools = filter(this.historicalSchools, [
      "systemSchoolId",
      stackId,
    ]);
    if (matchingSchools && matchingSchools.length > 0) {
      return matchingSchools[0].officialSchoolName;
    } else {
      return null;
    }
  }
}

export interface Point {
  denominator: number;
  name: string;
  numerator: number;
  visible: boolean;
  y: number;
}

export interface Series {
  name: string;
  visible: boolean;
  data: Point[];
  stack: string;
}

export interface Row {
  [key: string]:
    | number
    | {
        seriesName: string;
      };
}
